import Utils from './utils';

class Main {
  init() {
    this.assignAudioHandler();
    this.searchIcon();
    this.bookLinks();
    this.dialog();
    this.hamburger();
    this.mobileNavSubmenu();
    this.windowResize();
    this.enterViewport();
    this.accessibleDesktopNav();
  }

  /**
   * Audio play handlers
   *
   * @memberof Main
   */
  assignAudioHandler() {
    const slideAudioButton = document.getElementsByClassName('js-audio');

    Array.from(slideAudioButton, audioButton =>
      audioButton.addEventListener('click', this.audioPlay.bind(this))
    );
  }

  audioPlay(e) {
    const audio = e.currentTarget.querySelector('audio');

    if (!audio) {
      // console.log('no audio present');
      return;
    }

    if (audio.paused) {
      audio.play();
      if (!audio.paused) e.currentTarget.classList.add('playing');
    } else {
      audio.pause();
      if (audio.paused) {
        e.currentTarget.classList.remove('playing');
      }
    }
  }

  searchIcon() {
    const el = document.getElementById('search-bar');
    if (el) {
      const header = document.getElementById('js-header');

      const searchBarEnter = () => {
        header.classList.add('search-open');
      };
      const searchBarLeave = () => {
        if (!el.value) {
          header.classList.remove('search-open');
        }
      };

      el.addEventListener('focus', searchBarEnter, false);
      el.addEventListener('blur', searchBarLeave, false);
    }
  }

  bookLinks() {
    function docEventListener(e) {
      if (!e.target.closest('.js-books-cta')) {
        // eslint-disable-next-line no-use-before-define
        hideButtonLinks(e.target);
      } else {
        e.stopPropagation();
      }
    }

    const hideButtonLinks = () => {
      const openCTA = document.querySelector('.js-books-cta.open');
      openCTA.classList.remove('open');

      const hiddenButtonLinks = openCTA.querySelector('.js-book-links');
      hiddenButtonLinks.setAttribute('aria-hidden', 'true');
      document.removeEventListener('click', docEventListener);
    };
    const showButtonLinks = button => {
      const hiddenButtonLinks = button.querySelector('.js-book-links');
      hiddenButtonLinks.setAttribute('aria-hidden', 'false');

      button.classList.add('open');
      document.addEventListener('click', docEventListener);
    };

    const bookLinksClicked = e => {
      const clickedCTA = e.currentTarget;

      if (clickedCTA.classList.contains('open')) {
        hideButtonLinks(clickedCTA);
        // document.removeEventListener('click', docEventListener);
      } else {
        showButtonLinks(clickedCTA);
      }
    };

    Array.from(document.querySelectorAll('.js-books-cta')).map(link =>
      link.addEventListener('click', bookLinksClicked.bind(this))
    );
  }

  /**
   * Dialog pop up - announcement
   *
   * Drops cookie to determine if to show sitewide announcement popup
   */
  dialog() {
    if (document.getElementById('js-dialog')) {
      const dialogEl = document.getElementById('js-dialog');
      const cookieValue = dialogEl.getAttribute('data-announcement');
      const mainEl = document.getElementById('main');
      const dialog = new window.A11yDialog(dialogEl, mainEl);

      // Only show if cookie doesn't match attribute on dom (attribute is the value the cookie has if user has already been served dialog)
      if (Utils.getCookie('lmc_announcement') !== cookieValue) {
        Utils.setCookie('lmc_announcement', cookieValue, 7);
        dialog.show();
      }
    }
  }

  hamburger() {
    if (document.getElementById('js-hamburger')) {
      const hamburger = document.getElementById('js-hamburger');
      const header = document.getElementById('js-header');

      hamburger.addEventListener('click', () => {
        if (header.classList.contains('nav-open')) {
          this.closeMobileNav();
        } else {
          this.openMobileNav();
        }
      });
    }
  }

  closeMobileNav() {
    const header = document.getElementById('js-header');
    if (!header.classList.contains('nav-open')) return;

    const hamburger = document.getElementById('js-hamburger');
    const primaryNav = header.querySelector('.c-menu--primary');

    hamburger.classList.remove('is-active');
    header.classList.remove('nav-open');
    primaryNav.removeAttribute('style');
  }

  openMobileNav() {
    const hamburger = document.getElementById('js-hamburger');
    const header = document.getElementById('js-header');
    const primaryNav = header.querySelector('.c-menu--primary');

    hamburger.classList.add('is-active');
    header.classList.add('nav-open');
    primaryNav.style.height = `${primaryNav.scrollHeight}px`;
  }

  /**
   * Controls the showing and hiding of sub menus on mobile nav
   *
   * @memberof Main
   */
  mobileNavSubmenu() {
    const _this = this;
    const subMenu = document.getElementsByClassName('js-sub-menu');
    const subMenuButtons = document.getElementsByClassName(
      'js-sub-menu-button'
    );

    const subMenuClick = e => {
      // Make sure mobile nav is showing
      const hamburger = document.querySelector('#js-hamburger');
      const hamburgerStyles = getComputedStyle(hamburger, null);
      if (hamburgerStyles.display !== 'block') return;

      let menuItem = e.currentTarget;

      // If this is trigger by keypress for accessibility then ensure the keypress was enter
      if (e.type === 'keypress') {
        if (e.keyCode !== 13) return;
        menuItem = e.target.parentNode;
      }

      const subMenu = menuItem.querySelector('.c-menu--secondary');

      const primaryMenu = document
        .getElementById('js-header')
        .querySelector('.c-menu--primary');

      const closeSubMenu = () => {
        // icon.classList.remove('active');
        menuItem.classList.remove('menu-open');
        subMenu.style.height = '0';
        _this.addNegativeTabIndex(subMenu);
      };

      const openSubMenu = () => {
        menuItem.classList.add('menu-open');
        subMenu.style.height = `${subMenu.scrollHeight}px`;
        primaryMenu.style.height = 'auto';
        _this.removeSubItemsTabIndex(subMenu);
      };

      if (menuItem.classList.contains('menu-open')) {
        // console.log('menu item ', menuItem);
        closeSubMenu();
      } else {
        openSubMenu();
      }
    };

    Array.from(subMenu, button =>
      button.addEventListener('click', subMenuClick.bind(this))
    );
    Array.from(subMenuButtons, button =>
      button.addEventListener('keypress', subMenuClick.bind(this.parentNode))
    );
  }

  resetSubMenu() {
    // Check if any submenus are active
    const activeSubMenus = document.querySelectorAll(
      '.c-menu__item--primary.menu-open'
    );
    if (activeSubMenus.length < 1) return;

    // Remove all active states when a sub menu is open
    const removeSubMenuClasses = menuItem => {
      menuItem.classList.remove('menu-open');
      const subMenu = menuItem.querySelector('.c-menu--secondary');
      subMenu.removeAttribute('style');
    };

    Array.from(activeSubMenus, menuItem => removeSubMenuClasses(menuItem));
  }

  windowResize() {
    const debouncedResize = Utils.debounce(() => {
      this.resetSubMenu();
      this.closeMobileNav();
    }, 250);

    window.addEventListener('resize', debouncedResize);
  }

  enterViewport() {
    const enterViewport = el => {
      const elementWatcher = scrollMonitor.create(el);

      elementWatcher.fullyEnterViewport(() => {
        el.classList.add('entered');
        elementWatcher.destroy();
      });
    };

    const showcases = document.getElementsByClassName('js-showcase');
    Array.from(showcases, showcase => enterViewport(showcase));

    const imageModules = document.getElementsByClassName('js-image');
    Array.from(imageModules, image => enterViewport(image));
  }

  removeSubItemsTabIndex(menu) {
    const listItems = menu.getElementsByTagName('a');

    for (let i = 0; i < listItems.length; i++) {
      listItems[i].tabIndex = 0;
    }
  }

  addNegativeTabIndex(menu) {
    const listItems = menu.getElementsByTagName('a');

    for (let i = 0; i < listItems.length; i++) {
      listItems[i].tabIndex = -1;
    }
  }

  accessibleDesktopNav() {
    const _this = this;

    const focusEvent = e => {
      // Make sure desktop navigation is showing
      const hamburger = document.querySelector('#js-hamburger');
      const hamburgerStyles = getComputedStyle(hamburger, null);
      if (hamburgerStyles.display !== 'none') return;

      const link = e.target;

      // Make sure no sub menus open or tab is active
      if (document.querySelector('.menu-item-has-children.menu-open')) {
        const openMenu = document.querySelector(
          '.menu-item-has-children.menu-open'
        );
        _this.addNegativeTabIndex(openMenu);
        openMenu.classList.remove('menu-open');
      }

      if (document.querySelector('.c-menu__item.tab-active')) {
        document
          .querySelector('.c-menu__item.tab-active')
          .classList.remove('tab-active');
      }
      // If current item has child menu then open
      if (link.parentNode.classList.contains('menu-item-has-children')) {
        link.parentNode.classList.add('menu-open');
        // Remove the tab index
        _this.removeSubItemsTabIndex(
          link.parentNode.querySelector('.c-menu--secondary')
        );
      } else {
        link.parentNode.classList.add('tab-active');
      }
    };

    const blurEvent = () => {};

    const links = document.getElementsByClassName('c-menu__link--primary');
    Array.from(links, link =>
      link.addEventListener('focus', focusEvent.bind(this))
    );
    Array.from(links, link =>
      link.addEventListener('blur', blurEvent.bind(this))
    );
  }
}

export default Main;
